"use strict";
/**
 * fetch
 *
 * ### Example
 * ```
 * fetch('/test').then(response => {
 *     console.log(response);
 * }).catch(error => {
 *     console.log(error);
 * });
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("whatwg-fetch");
var object_to_query_1 = require("./object-to-query");
var nativeFetch = window.fetch;
var defaultFecthOptions = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 8000
};
var timeoutTimer;
function fetch(url, options) {
    options = tslib_1.__assign({}, defaultFecthOptions, options);
    if (options.method.toUpperCase() !== 'GET') {
        options.body = typeof options.data === 'string'
            ? options.data
            : object_to_query_1.objectToQuery(options.data || {});
    }
    return Promise.race([
        nativeFetch(url, options),
        new Promise(function (resolve, reject) {
            clearTimer();
            timeoutTimer = setTimeout(function () { return reject(new Error('网络繁忙')); }, options.timeout);
        })
    ]).then(checkStatus)
        .then(function (res) { return res.json(); });
}
exports.fetch = fetch;
function checkStatus(response) {
    clearTimer();
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    else {
        throw new Error(response.statusText);
    }
}
function clearTimer() {
    if (typeof timeoutTimer === 'number') {
        clearTimeout(timeoutTimer);
    }
}
